import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicAppRegistryComponent } from './dynamic-app-registry.component';
import { PagesModule } from '../dynamic-app/component/pages/pages.module';
import { BuildingBlockModule } from '../dynamic-app/component/building-block/building-block.module';
import { OaoModule } from '../oao/oao.module';
import { OlaModule } from '../ola/ola.module';
import { CustomPagesModule } from '../dynamic-app/component/custom-pages/custom-pages.module';
import { CustomCardsModule } from '../dynamic-app/component/custom-cards/custom-cards.module';
import { ControlsModule } from '@workflow/dynamic-render/building-block/controls/controls.module';
import { DynamicWorkflowModule } from '@workflow/dynamic-workflow.module';
import { SharedModule } from '@shared/shared.module';
import { CommonModalsModule } from '../common-modals/common-modals.module';

@NgModule({
  declarations: [DynamicAppRegistryComponent],
  imports: [
    CommonModule,
    DynamicWorkflowModule,
    BuildingBlockModule,
    PagesModule,
    OaoModule,
    OlaModule,
    CustomPagesModule,
    CustomCardsModule,
    ControlsModule,
    SharedModule,
    CommonModalsModule
  ],
  exports: [DynamicAppRegistryComponent],
  providers: []
})
export class DynamicAppRegistryModule {}
